
<div class="px-3">

  <page-title 
      icon="money-bill"
      title="Webhook Events" 
      description="Analyze the data of webhook events of a creditor">
  </page-title>

    <div class="mt-4 flex flex-wrap justify-content-between gap-2">
    
        
        <div class="flex flex-wrap gap-2" >
            <creditor-autocomplete (onSelect)="onSelectCreditor($event)"></creditor-autocomplete>       
            <div class="p-float-label">
                <p-calendar [(ngModel)]="fromDate"
                            inputId="fromDate"
                            dateFormat="mm/dd/yy"
                            showIcon="true"
                            [showButtonBar]="true">
                </p-calendar>
                <label for="fromDate">From Date</label>
            </div>
            
            <div class="p-float-label">
                <p-calendar [(ngModel)]="toDate"
                            inputId="toDate"
                            dateFormat="mm/dd/yy"
                            showIcon="true"
                            [showButtonBar]="true">
                </p-calendar>
                <label for="toDate">To Date</label>
            </div>
        </div>

        <div class="flex justify-content-end gap-2" style="padding-top: 4px;">
            <remitter-button
                    label="Get"
                    icon='play'
                    severity="primary"
                    (click)="getReport()"
                    [disabled]="!selectedCreditorId || !fromDate || !toDate"
            />
            <remitter-button
                    label="Export"
                    icon='file-export'
                    severity="secondary"
                    (click)="exportReport()"
                    [disabled]="!selectedCreditorId || !fromDate || !toDate"
            />
            
        </div>
    </div>

    <div class="mt-4 pt-2 px-3">

       <div 
            *ngIf="!hasTableData && hasClickedSearch"
            style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                🚫 No records found for {{ selectedCreditorCompanyName }}
        </div>
        <p-table 
            *ngIf="hasTableData"
            [value]="reportData" 
            [paginator]="true" 
            [rows]="25" 
            [tableStyle]="{ 'min-width': '50rem' }" 
            [rowsPerPageOptions]="[25, 100]">
            <ng-template pTemplate="header">
                <tr class="text-xs">
                    <th>Webhook Event Id</th>
                    <th>Account InvoiceId Id</th>
                    <th>Attempts</th>  
                    <th>Dismissed</th>
                    <th>Is Successful</th>
                    <th>Url Called</th>
                    <th>Webhook Operation</th>
                    <th>Message Type</th>
                    <th>Is Adhoc Payment</th>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-report>
                <tr class="text-xs">
                    <td>{{ report.webhookEventId }}</td>
                    <td>{{ report.accountInvoiceId }}</td>
                    <td>{{ report.attempts }}</td>                
                    <td>{{ report.dismissed }}</td>
                    <td>{{ report.isSuccessful }}</td>
                    <td>{{ report.urlCalled }}</td>
                    <td>{{ report.webhookOperation }}</td>
                    <td>{{ report.messageType}}</td>
                    <td>{{ report.isAdhocPayment}}</td>                    
                </tr>
            </ng-template>
        </p-table>

    </div>
</div>
